// This file was auto-generated by Fern from our API Definition.
export const RequestType = {
    Unknown: "unknown",
    Router: "router",
    Worker: "worker",
};
